import React from "react";

import { StyledSVG } from "../StyledIcon";

export const ExperimentsIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M7.19697 6.22222L7.85924 6.57422C7.91684 6.46584 7.94697 6.34497 7.94697 6.22222H7.19697ZM2 16L1.33773 15.648C1.21418 15.8805 1.22155 16.1607 1.35715 16.3863C1.49276 16.612 1.73674 16.75 2 16.75L2 16ZM16 16V16.75C16.2633 16.75 16.5072 16.612 16.6428 16.3863C16.7785 16.1607 16.7858 15.8805 16.6623 15.648L16 16ZM10.803 6.22222H10.053C10.053 6.34497 10.0832 6.46584 10.1408 6.57422L10.803 6.22222ZM10.803 2H11.553C11.553 1.58579 11.2172 1.25 10.803 1.25V2ZM7.19697 2V1.25C6.78276 1.25 6.44697 1.58579 6.44697 2H7.19697ZM2 16.75H16V15.25H2V16.75ZM11.553 6.22222V2H10.053V6.22222H11.553ZM10.803 1.25H7.19697V2.75H10.803V1.25ZM6.44697 2V6.22222H7.94697V2H6.44697ZM6.5347 5.87022L1.33773 15.648L2.66227 16.352L7.85924 6.57422L6.5347 5.87022ZM10.1408 6.57422L15.3377 16.352L16.6623 15.648L11.4653 5.87022L10.1408 6.57422Z"
        fill={iconColor}
      />
      <path
        d="M3.80036 11.3244C3.42696 11.5037 3.26961 11.9517 3.4489 12.3251C3.62819 12.6985 4.07624 12.8559 4.44964 12.6766L3.80036 11.3244ZM14.5061 13.7436C14.9165 13.6874 15.2037 13.3092 15.1475 12.8988C15.0914 12.4884 14.7132 12.2013 14.3028 12.2574L14.5061 13.7436ZM4.44964 12.6766C4.90592 12.4575 5.68888 12.1872 6.499 12.1096C7.32197 12.0307 8.03435 12.1615 8.51087 12.5699L9.48706 11.431C8.56359 10.6395 7.35964 10.5202 6.35595 10.6164C5.33943 10.7138 4.3854 11.0435 3.80036 11.3244L4.44964 12.6766ZM8.51087 12.5699C9.38122 13.3159 10.6089 13.6312 11.6819 13.7578C12.7766 13.887 13.8422 13.8344 14.5061 13.7436L14.3028 12.2574C13.7482 12.3332 12.811 12.3806 11.8577 12.2681C10.8825 12.1531 10.0167 11.885 9.48706 11.431L8.51087 12.5699Z"
        fill={iconColor}
      />
    </StyledSVG>
  );
};
